import { styled } from '@mui/material/styles';
import { Document, Page } from 'react-pdf';

const StyledDocument = styled(Document)({
  width: '100%',
  height: 'auto',
  maxWidth: '100%',
  minWidth: 0,
});

const PageContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingRight: '2rem',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    paddingRight: 0,
  },
}));

const LoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  '& p': {
    fontSize: '1.6rem',
    color: '#888',
  },
});

const StyledPage = styled(Page)({
  maxWidth: '100%',
  height: 'auto',
  filter: 'contrast(1.2) brightness(1.1) sharpen(0.7)',
  '& canvas, & .react-pdf__Page__textContent, & .react-pdf__Page__annotations': {
    maxWidth: '100% !important',
  },
});

export { StyledDocument, PageContainer, LoadingContainer, StyledPage };
